<template>
  <div class="company">
    <img :src="backgroundTop" class="academy__pennellata-top">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"
    />
    <!-- Slides -->
    <InternalPageSlides 
      v-if="typeof currentPage.fields.layoutedContents !== 'undefined'"
      :slidesArray="currentPage.fields.layoutedContents"
      :bgImage="backgroundHrz"
    />
    <InternalNextPages
      :services="true"
      :quality="true"/>
    <FooterArea/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HeroText from '@/components/HeroText/HeroText.vue'
import InternalPageSlides from '@/components/InternalPageSlides/InternalPageSlides.vue'
import InternalNextPages from '@/components/InternalNextPages/InternalNextPages.vue'
import FooterArea from '@/components/FooterArea/FooterArea.vue'

export default {
  name: 'Company',
  components: {
    HeroText,
    InternalPageSlides,
    InternalNextPages,
    FooterArea
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    backgroundTop: require('@/assets/company/pennellata-top.jpg'),
    backgroundHrz: require('@/assets/company/pennellata-horizontal.jpg')
  })
}
</script>

<style lang="scss">
  @import './../../assets/scss/breakpoint.scss';

  .hero-text.hero-text--internalPage{
    margin-bottom: 4rem;
    @include media(">=medium"){
      margin-bottom: 6rem;
    }
    @include media(">=large"){
      margin-bottom: 8rem;
    }
    @include media(">=xlarge"){
      margin-bottom: 9rem;
    }
  }

  .company{
    background-color: #effefd;
  }
</style>